import { Award, Star, Users } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import standImage from '@/assets/stand-passcar.png';
import { useDynamicStats } from '@/hooks/use-dynamic-stats';
import { useCountUp } from '@/hooks/use-count-up';

export function AboutSection() {
  const { t } = useI18n();
  const { years, clients } = useDynamicStats();

  const yearsCounter = useCountUp({ end: years, duration: 1500 });
  const clientsCounter = useCountUp({ end: clients, duration: 2000 });

  const highlights = [
    { key: 'experience', icon: Award, displayValue: `${yearsCounter.count}+`, ref: yearsCounter.ref },
    { key: 'trust', icon: Star, displayValue: '100%', ref: null },
    { key: 'quality', icon: Users, displayValue: `${clientsCounter.count}+`, ref: clientsCounter.ref },
  ];

  return (
    <section id="sobre" className="py-20 bg-card/50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Content */}
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold">
              {t.about.title}
            </h2>
            <p className="text-xl text-primary-text font-medium">
              {t.about.subtitle}
            </p>
            <p className="text-muted-foreground leading-relaxed">
              {t.about.description}
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-3 gap-4 pt-6">
              {highlights.map(({ key, icon: Icon, displayValue, ref }) => {
                const text = t.about[key as keyof typeof t.about];

                return (
                  <div key={key} className="text-center" ref={ref}>
                    <div className="inline-flex items-center justify-center p-3 rounded-2xl bg-primary/10 mb-3">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <div className="text-2xl font-bold text-primary-text">{displayValue}</div>
                    <div className="text-sm text-muted-foreground mt-1">
                      {typeof text === 'string' ? text : ''}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="glass-card p-2 rounded-3xl overflow-hidden">
              <img 
                src={standImage} 
                alt="Stand PassCar - Stand de Automóveis" 
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary/20 rounded-full blur-2xl" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-primary/10 rounded-full blur-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
